/*
 * sb-dc-fabrichandle.js
 * ------------------------------------------------------------
 * The in-house design center points at two deleted "fabric step & repeat"
 * product handles. Both were removed in a catalog cleanup; this file makes the
 * design center use the live products instead, without any catalog change.
 *
 * 1) CUSTOM fabric step & repeat ($2.99/sqft, custom W x H) - entered from the
 *    fabric product page. Its card fetches /products/fabric-step-repeat-banners.js
 *    (deleted). Live twin: custom-fabric-step-repeat-banner (445 variants, seeded
 *    in Supabase dc_variants). Handled by a plain URL rewrite so sb-dc-varfix.js
 *    still splices the live variants.
 *
 * 2) FIXED-SIZE fabric step & repeat ("Banner Only", 8ft tall, fixed price grid)
 *    - entered from Free Design Tool > Fabric Step & Repeat > a template. Its card
 *    (__CAT handle fabric-step-and-repeat-banner, fixedOnly, no baked variant id)
 *    has no live product, so "Approve and add to cart" fetched
 *    /products/fabric-step-and-repeat-banner.js and 404'd. The live replacement is
 *    split one product per size, each a single variant at the exact price the
 *    editor shows:
 *        8ft x8  -> 8x8-fabric-step-repeat-banner   $160
 *       10ft x8  -> 10x8-fabric-step-repeat-banner  $200
 *       12ft x8  -> 12x8-fabric-step-repeat-banner  $288
 *       16ft x8  -> 16x8-fabric-step-repeat-banner  $384
 *       20ft x8  -> 20x8-fabric-step-repeat-banner  $480
 *       30ft x8  -> 30x8-fabric-step-repeat-banner  $717.60
 *    For this handle the shim reads the selected width from window.__dcSpec and
 *    returns a product built from the matching per-size product's REAL variant id
 *    and price, with a normalized "W / 8" variant title so the editor matches the
 *    chosen size. The line added to the cart is therefore the correct live
 *    product at the correct fixed price.
 *
 * Load order: wraps window.fetch OUTSIDE (after) sb-dc-varfix.js, so for case 1
 * varfix still sees the rewritten live handle, and for case 2 this shim answers
 * before varfix. Do NOT edit sb-dc-handle.js or the big app bundle.
 *
 * Only the product .js read is changed. A plain "view product" HTML link to a
 * dead handle, if any, is out of scope.
 *
 * To retire: once the design center is re-pointed at live products at the source
 * (a new app build, or the single fabric-step-and-repeat-banner product is
 * recreated with size variants like vinyl-step-and-repeat-banner), delete this
 * file, its section sections/sb-dc-fabrichandleload.liquid, and the "fabrichandle"
 * entry in templates/page.design-center.json. The per-size variant ids are read
 * live at request time, so they need no maintenance here.
 *
 * Check window.__dcFabricHandle().
 * ------------------------------------------------------------
 */
(function () {
  "use strict";

  var SIMPLE = { "fabric-step-repeat-banners": "custom-fabric-step-repeat-banner" };
  var FIXED_HANDLE = "fabric-step-and-repeat-banner";
  var FIXED_SIZES = { 8: 1, 10: 1, 12: 1, 16: 1, 20: 1, 30: 1 };
  var RE = /\/products\/([^\/?#]+)\.js([?#]|$)/;
  var state = { rewrites: 0, synth: 0, last: null };

  var orig = window.fetch;
  if (typeof orig !== "function" || orig.__dcFabricWrapped) return;

  function handleOf(u) {
    try { var m = String(u).match(RE); return m ? m[1] : null; } catch (e) { return null; }
  }

  function selectedW() {
    try {
      var s = window.__dcSpec;
      if (s && typeof s.widthIn === "number") return Math.round(s.widthIn / 12);
    } catch (e) {}
    return null;
  }

  function synthResponse(W) {
    var live = W + "x8-fabric-step-repeat-banner";
    return orig.call(window, "/products/" + live + ".js").then(function (r) {
      if (!r.ok) throw new Error("per-size " + live + " HTTP " + r.status);
      return r.json();
    }).then(function (p) {
      try {
        p.handle = FIXED_HANDLE;
        var t = W + " / 8";
        (p.variants || []).forEach(function (v) {
          v.title = t;
          v.option1 = String(W);
          v.option2 = "8";
          v.options = [String(W), "8"];
          v.public_title = t;
        });
        state.synth++;
        state.last = { fixed: FIXED_HANDLE, live: live, w: W };
      } catch (e) {}
      return new Response(JSON.stringify(p), {
        status: 200,
        headers: { "Content-Type": "application/json" }
      });
    });
  }

  var wrapped = function (input, init) {
    try {
      var url = (typeof input === "string") ? input : (input && input.url);
      var h = handleOf(url);
      if (h) {
        if (h === FIXED_HANDLE) {
          var W = selectedW();
          if (W && FIXED_SIZES[W]) return synthResponse(W);
        } else if (SIMPLE[h]) {
          var nu = String(url).replace("/products/" + h + ".js", "/products/" + SIMPLE[h] + ".js");
          state.rewrites++;
          state.last = { from: h, to: SIMPLE[h] };
          if (typeof input === "string") return orig.call(this, nu, init);
          return orig.call(this, new Request(nu, input), init);
        }
      }
    } catch (e) {}
    return orig.call(this, input, init);
  };
  wrapped.__dcFabricWrapped = true;
  window.fetch = wrapped;

  window.__dcFabricHandle = function () {
    return { rewrites: state.rewrites, synth: state.synth, last: state.last, simple: SIMPLE, fixedSizes: Object.keys(FIXED_SIZES) };
  };
})();
